import { useContext } from "react";
import DeviceDisplayContext from "../contexts/DeviceDisplayProvider";

const useDeviceDisplay = () => {
  return useContext(DeviceDisplayContext);
};

export default useDeviceDisplay;
